var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMagnifier(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "magnifier 1",
    clipPath: "url(#clip0_6_858)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.0337 17.3125C25.9888 13.3572 25.9888 6.92161 22.0337 2.9664C18.0785 -0.988801 11.643 -0.988801 7.68783 2.9664C4.33238 6.32186 3.8242 11.3123 6.16192 15.2093C6.16192 15.2093 6.32984 15.491 6.10305 15.7176C4.80923 17.0113 0.927558 20.8931 0.927558 20.8931C-0.102578 21.9231 -0.347811 23.3635 0.56571 24.2772L0.722997 24.4343C1.63652 25.348 3.07698 25.1029 4.10704 24.0727C4.10704 24.0727 7.9805 20.1992 9.27166 18.9081C9.50932 18.6705 9.79095 18.8384 9.79095 18.8384C13.6879 21.176 18.6783 20.6679 22.0337 17.3125ZM9.56062 15.4396C6.63813 12.5171 6.63821 7.76192 9.5607 4.83943C12.4832 1.91702 17.2384 1.91694 20.1608 4.83943C23.0833 7.76184 23.0833 12.5171 20.1608 15.4396C17.2383 18.3619 12.4832 18.3619 9.56062 15.4396Z",
    fill: "#D9EEFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.2079 9.53749C10.0719 9.53749 9.93364 9.51075 9.80035 9.45446C9.26793 9.22912 9.01883 8.61479 9.24417 8.08228C10.6605 4.73529 14.5356 3.16459 17.8825 4.5809C18.415 4.80624 18.6641 5.42057 18.4387 5.95307C18.2133 6.48558 17.5991 6.73451 17.0665 6.50925C14.783 5.54298 12.1388 6.61468 11.1726 8.89819C11.0036 9.29757 10.6159 9.53749 10.2079 9.53749Z",
    fill: "#D9EEFF"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_858"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifier);
export default __webpack_public_path__ + "static/media/magnifier.b39788b9ca2c1dc000053ab3f9470d1b.svg";
export { ForwardRef as ReactComponent };